import Editor from "Components/Form/Editor/Editor";
import React, { useEffect, useState } from "react";
import { Card, CardBody, CardTitle } from "reactstrap";
import Spinner from "Components/UI/Spinner";
import { Container } from "reactstrap";
import Breadcrumb from "Components/UI/Breadcrumb";
import { getPages, updatePage } from "helpers/API Calls/System & Settings/Pages";

function Contact() {
  const [content, setContent] = useState("");
  const [isSubmitting, setIsSubmitting] = useState<boolean>(false);
  const [isLoading, setIsLoading] = useState<boolean>(true);
  const [data, setData] = useState<any>(null);

  useEffect(() => {
    const fetchData = async () => {
      setIsLoading(true);
      const response = await getPages('limit=1&page_type_id=4');
      if (response.success) {
        const page_data = response.data?.items?.[0];
        setData(page_data);
        setContent(page_data?.content);
      }
      setIsLoading(false);
    };
    fetchData();
  }, []);

  const onSubmit = async () => {
    setIsSubmitting(true);
    const pageData = {
        title: data.title,
        content,
        is_seo: 0,
        page_type_id: 4,
        is_featured: 0,
        status: 1,
    };

    await updatePage(data.id || '', {data: pageData });
    setIsSubmitting(false);
  };

  return (
     <div className="page-content">
      <Container fluid>
        <Breadcrumb items={[{ label: "Contact Us" }]} />
    {isLoading ? <div className="position-relative vh-100"><Spinner/></div>
        :
    <Card>
        <CardBody>
        <CardTitle tag="h4" className="mb-4">
            Contact Us
        </CardTitle>
        <div className="mb-3">
            <Editor content={content} setContent={setContent} />
        </div>
        <div className="text-end mt-3">
            <button className="btn btn-primary" onClick={onSubmit}>
            {isSubmitting ? "Update..." : "Update Content"}
            </button>
        </div>
        </CardBody>
    </Card>}
    </Container>
    </div>
  );
}

export default Contact;
